import { render, staticRenderFns } from "./ImportBox.vue?vue&type=template&id=51570707&"
import script from "./ImportBox.vue?vue&type=script&lang=js&"
export * from "./ImportBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports